<template>
  <div class="">
    <el-select ref="brands" v-model="brandId" @change="selectBrand" filterable placeholder="请选择品牌">
      <el-option
        v-for="item in brands"
        :key="item.name"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
    <el-select ref="series" v-model="seriesId" @change="selectSeries" filterable placeholder="请选择车系">
      <el-option
        v-for="item in series"
        :key="item.name"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
  </div>

  <!-- /.navbar-static-side -->
</template>

<script>
import Config from '../framework/configs/Config'
import BrandSeriesModel from '../framework/models/brandSeriesModel'
// let provinces = require('../framework/data/area.json');
export default {
  name: 'brand-and-series-select',
  data: function (){
    return {
      baseImageUrl: Config.imageUrl,
      datas:[],
      brandId: null,
      brands: [],
      seriesId: null,
      series: [],
      props: {
        label: 'name',
        value: 'id',
        children: 'datas'
      },
      brandPosition: null,
      seariesPosition: null,
      areaCode: []
    }
  },
  mounted: function () {
    this.loadBrands()
  },
  methods: {
    selectBrand: function (brandId) {
      let _this = this

      if(!brandId){
        return
      }

      this.series = []
      this.seriesId = null
      

      let params = {
        brandId: brandId
      }

      let listener = {
        success: function (dataInfo) {
          let datas = dataInfo.datas
          _this.series = datas
        }
      }
      BrandSeriesModel.findBaseSeriesByBrandIdForCDSystem(_this, params,listener)


      //获取品牌信息
      let brandRefs = this.$refs['brands'];
      let brandPosition = brandRefs.selected.index
      let brandInfo = this.brands[brandPosition]

      if(brandInfo){
        this.$emit('onChanged',brandInfo)
      }

    },
    selectSeries: function(seriesId) {

      //获取车系信息
      let seriesRef = this.$refs['series'];
      let position = seriesRef.hoverIndex
      let seriesInfo = this.series[position]

      //获取品牌信息
      let brandRefs = this.$refs['brands'];
      let brandPosition = brandRefs.hoverIndex
      let brandInfo = this.brands[brandPosition]

      if(seriesInfo&&brandInfo){
        this.$emit('onChanged',brandInfo,seriesInfo)
      }

    },
    clear: function () {
      this.areaCode = []
      this.brandPosition = null
      this.seariesPosition = null
      this.seriesId = null
      this.brandId = null
    },
    loadBrands: function () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          _this.brands = dataInfo.datas
        }
      }
      BrandSeriesModel.findBaseBrandForCDSystem(_this, listener)
    }
  }
}
</script>
